export default __webpack_public_path__ + "static/media/chaussure.2fa5e061.jpeg";